import React, { FC } from 'react';

export const MinigamesSkeleton: FC = () => (
  <div className="minigames-page">
    <div className="main">
      <div className="mini-games-top">
        <div className="skeleton skeleton--hero" />
        <div className="skeleton skeleton--tile" />
        <div className="skeleton skeleton--tile" />
        <div className="skeleton skeleton--tile" />
        <div className="skeleton skeleton--tile" />
        <div className="skeleton skeleton--banner" />
      </div>
      <div className="mini-games-remaining">
        {Array.from({ length: 4 * 10 }, (_, i) => (
          <div key={i} className="skeleton skeleton--tile" />
        ))}
      </div>
    </div>
  </div>
);
